module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2016-06-27",
		"endpointPrefix": "rekognition",
		"jsonVersion": "1.1",
		"protocol": "json",
		"serviceFullName": "Amazon Rekognition",
		"signatureVersion": "v4",
		"targetPrefix": "RekognitionService",
		"uid": "rekognition-2016-06-27"
	},
	"operations": {
		"CompareFaces": {
			"input": {
				"type": "structure",
				"required": [
					"SourceImage",
					"TargetImage"
				],
				"members": {
					"SourceImage": {
						"shape": "S2"
					},
					"TargetImage": {
						"shape": "S2"
					},
					"SimilarityThreshold": {
						"type": "float"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"SourceImageFace": {
						"type": "structure",
						"members": {
							"BoundingBox": {
								"shape": "Sb"
							},
							"Confidence": {
								"type": "float"
							}
						}
					},
					"FaceMatches": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Similarity": {
									"type": "float"
								},
								"Face": {
									"shape": "Sf"
								}
							}
						}
					},
					"UnmatchedFaces": {
						"type": "list",
						"member": {
							"shape": "Sf"
						}
					},
					"SourceImageOrientationCorrection": {},
					"TargetImageOrientationCorrection": {}
				}
			}
		},
		"CreateCollection": {
			"input": {
				"type": "structure",
				"required": [
					"CollectionId"
				],
				"members": {
					"CollectionId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"StatusCode": {
						"type": "integer"
					},
					"CollectionArn": {}
				}
			}
		},
		"DeleteCollection": {
			"input": {
				"type": "structure",
				"required": [
					"CollectionId"
				],
				"members": {
					"CollectionId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"StatusCode": {
						"type": "integer"
					}
				}
			}
		},
		"DeleteFaces": {
			"input": {
				"type": "structure",
				"required": [
					"CollectionId",
					"FaceIds"
				],
				"members": {
					"CollectionId": {},
					"FaceIds": {
						"shape": "Sw"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"DeletedFaces": {
						"shape": "Sw"
					}
				}
			}
		},
		"DetectFaces": {
			"input": {
				"type": "structure",
				"required": [
					"Image"
				],
				"members": {
					"Image": {
						"shape": "S2"
					},
					"Attributes": {
						"shape": "S10"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"FaceDetails": {
						"type": "list",
						"member": {
							"shape": "S14"
						}
					},
					"OrientationCorrection": {}
				}
			}
		},
		"DetectLabels": {
			"input": {
				"type": "structure",
				"required": [
					"Image"
				],
				"members": {
					"Image": {
						"shape": "S2"
					},
					"MaxLabels": {
						"type": "integer"
					},
					"MinConfidence": {
						"type": "float"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Labels": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Name": {},
								"Confidence": {
									"type": "float"
								}
							}
						}
					},
					"OrientationCorrection": {}
				}
			}
		},
		"DetectModerationLabels": {
			"input": {
				"type": "structure",
				"required": [
					"Image"
				],
				"members": {
					"Image": {
						"shape": "S2"
					},
					"MinConfidence": {
						"type": "float"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ModerationLabels": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Confidence": {
									"type": "float"
								},
								"Name": {},
								"ParentName": {}
							}
						}
					}
				}
			}
		},
		"GetCelebrityInfo": {
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"Id": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Urls": {
						"shape": "S1u"
					},
					"Name": {}
				}
			}
		},
		"IndexFaces": {
			"input": {
				"type": "structure",
				"required": [
					"CollectionId",
					"Image"
				],
				"members": {
					"CollectionId": {},
					"Image": {
						"shape": "S2"
					},
					"ExternalImageId": {},
					"DetectionAttributes": {
						"shape": "S10"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"FaceRecords": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Face": {
									"shape": "S21"
								},
								"FaceDetail": {
									"shape": "S14"
								}
							}
						}
					},
					"OrientationCorrection": {}
				}
			}
		},
		"ListCollections": {
			"input": {
				"type": "structure",
				"members": {
					"NextToken": {},
					"MaxResults": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"CollectionIds": {
						"type": "list",
						"member": {}
					},
					"NextToken": {}
				}
			}
		},
		"ListFaces": {
			"input": {
				"type": "structure",
				"required": [
					"CollectionId"
				],
				"members": {
					"CollectionId": {},
					"NextToken": {},
					"MaxResults": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Faces": {
						"type": "list",
						"member": {
							"shape": "S21"
						}
					},
					"NextToken": {}
				}
			}
		},
		"RecognizeCelebrities": {
			"input": {
				"type": "structure",
				"required": [
					"Image"
				],
				"members": {
					"Image": {
						"shape": "S2"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"CelebrityFaces": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Urls": {
									"shape": "S1u"
								},
								"Name": {},
								"Id": {},
								"Face": {
									"shape": "Sf"
								},
								"MatchConfidence": {
									"type": "float"
								}
							}
						}
					},
					"UnrecognizedFaces": {
						"type": "list",
						"member": {
							"shape": "Sf"
						}
					},
					"OrientationCorrection": {}
				}
			}
		},
		"SearchFaces": {
			"input": {
				"type": "structure",
				"required": [
					"CollectionId",
					"FaceId"
				],
				"members": {
					"CollectionId": {},
					"FaceId": {},
					"MaxFaces": {
						"type": "integer"
					},
					"FaceMatchThreshold": {
						"type": "float"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"SearchedFaceId": {},
					"FaceMatches": {
						"shape": "S2j"
					}
				}
			}
		},
		"SearchFacesByImage": {
			"input": {
				"type": "structure",
				"required": [
					"CollectionId",
					"Image"
				],
				"members": {
					"CollectionId": {},
					"Image": {
						"shape": "S2"
					},
					"MaxFaces": {
						"type": "integer"
					},
					"FaceMatchThreshold": {
						"type": "float"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"SearchedFaceBoundingBox": {
						"shape": "Sb"
					},
					"SearchedFaceConfidence": {
						"type": "float"
					},
					"FaceMatches": {
						"shape": "S2j"
					}
				}
			}
		}
	},
	"shapes": {
		"S2": {
			"type": "structure",
			"members": {
				"Bytes": {
					"type": "blob"
				},
				"S3Object": {
					"type": "structure",
					"members": {
						"Bucket": {},
						"Name": {},
						"Version": {}
					}
				}
			}
		},
		"Sb": {
			"type": "structure",
			"members": {
				"Width": {
					"type": "float"
				},
				"Height": {
					"type": "float"
				},
				"Left": {
					"type": "float"
				},
				"Top": {
					"type": "float"
				}
			}
		},
		"Sf": {
			"type": "structure",
			"members": {
				"BoundingBox": {
					"shape": "Sb"
				},
				"Confidence": {
					"type": "float"
				},
				"Landmarks": {
					"shape": "Sg"
				},
				"Pose": {
					"shape": "Sj"
				},
				"Quality": {
					"shape": "Sl"
				}
			}
		},
		"Sg": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"Type": {},
					"X": {
						"type": "float"
					},
					"Y": {
						"type": "float"
					}
				}
			}
		},
		"Sj": {
			"type": "structure",
			"members": {
				"Roll": {
					"type": "float"
				},
				"Yaw": {
					"type": "float"
				},
				"Pitch": {
					"type": "float"
				}
			}
		},
		"Sl": {
			"type": "structure",
			"members": {
				"Brightness": {
					"type": "float"
				},
				"Sharpness": {
					"type": "float"
				}
			}
		},
		"Sw": {
			"type": "list",
			"member": {}
		},
		"S10": {
			"type": "list",
			"member": {}
		},
		"S14": {
			"type": "structure",
			"members": {
				"BoundingBox": {
					"shape": "Sb"
				},
				"AgeRange": {
					"type": "structure",
					"members": {
						"Low": {
							"type": "integer"
						},
						"High": {
							"type": "integer"
						}
					}
				},
				"Smile": {
					"type": "structure",
					"members": {
						"Value": {
							"type": "boolean"
						},
						"Confidence": {
							"type": "float"
						}
					}
				},
				"Eyeglasses": {
					"type": "structure",
					"members": {
						"Value": {
							"type": "boolean"
						},
						"Confidence": {
							"type": "float"
						}
					}
				},
				"Sunglasses": {
					"type": "structure",
					"members": {
						"Value": {
							"type": "boolean"
						},
						"Confidence": {
							"type": "float"
						}
					}
				},
				"Gender": {
					"type": "structure",
					"members": {
						"Value": {},
						"Confidence": {
							"type": "float"
						}
					}
				},
				"Beard": {
					"type": "structure",
					"members": {
						"Value": {
							"type": "boolean"
						},
						"Confidence": {
							"type": "float"
						}
					}
				},
				"Mustache": {
					"type": "structure",
					"members": {
						"Value": {
							"type": "boolean"
						},
						"Confidence": {
							"type": "float"
						}
					}
				},
				"EyesOpen": {
					"type": "structure",
					"members": {
						"Value": {
							"type": "boolean"
						},
						"Confidence": {
							"type": "float"
						}
					}
				},
				"MouthOpen": {
					"type": "structure",
					"members": {
						"Value": {
							"type": "boolean"
						},
						"Confidence": {
							"type": "float"
						}
					}
				},
				"Emotions": {
					"type": "list",
					"member": {
						"type": "structure",
						"members": {
							"Type": {},
							"Confidence": {
								"type": "float"
							}
						}
					}
				},
				"Landmarks": {
					"shape": "Sg"
				},
				"Pose": {
					"shape": "Sj"
				},
				"Quality": {
					"shape": "Sl"
				},
				"Confidence": {
					"type": "float"
				}
			}
		},
		"S1u": {
			"type": "list",
			"member": {}
		},
		"S21": {
			"type": "structure",
			"members": {
				"FaceId": {},
				"BoundingBox": {
					"shape": "Sb"
				},
				"ImageId": {},
				"ExternalImageId": {},
				"Confidence": {
					"type": "float"
				}
			}
		},
		"S2j": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"Similarity": {
						"type": "float"
					},
					"Face": {
						"shape": "S21"
					}
				}
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/rekognition-2016-06-27.min.json
// module id = 1391
// module chunks = 0